import React from 'react';
import { useLocation } from 'react-router-dom';
import './PlaceholderPage.css';

export const PlaceholderPage: React.FC = () => {
  const location = useLocation();

  return (
    <div className="placeholder-container">
      <div className="placeholder-content">
        <div className="placeholder-lock-icon">🔒</div>
        <div className="placeholder-protected-label">Protected Area</div>
        <h1 className="placeholder-route">{location.pathname}</h1>
      </div>
    </div>
  );
};
